<span
  (mouseover)="this.handleShowHelp()"
  (mouseout)="this.handleHideHelp()"
  style="font-size: 0.8em; font-weight: normal"
  >(what's this?)</span
>

<div
  class="helpContainer"
  style="font-size: 0.8em; font-weight: normal"
  (mouseover)="this.handleShowHelp()"
  (mouseout)="this.handleHideHelp()"
>
  @if (showHelp) {
    <div>
      {{ this.helpText }}
    </div>
  }
</div>
<!--
<div class="helpContainer">
  <img src="../../../assets/images/helpicon.png" name="icon" alt="?" (mouseover)="showHelp = true" (mouseout)="showHelp = false" />

</div>
-->
